import LookupPrescreenId from './LookupPrescreenId';

export default LookupPrescreenId;
